import React from 'react';
import { Dialog, DialogProps } from '../../ui';
import { ExitIcon } from '../../icons';
import useAuth from '../../../hooks/utils/useAuth';
import { resolveTheme } from '../../../themes';

export interface LogoutModalProps extends DialogProps {
  dataTestId?: string;
}

export const LogoutModal: React.FC<LogoutModalProps> = ({
  className,
  onClose,
  dataTestId,
  ...props
}: LogoutModalProps) => {
  const { logout } = useAuth();
  const theme = resolveTheme();

  const handleLogout = () => {
    logout();
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog
      data-testid={dataTestId}
      onClose={onClose}
      closeOnOutsideClick={true}
      className="shadow-modal backdrop:bg-modalBackdropColor w-full max-w-md rounded-xl bg-white p-0"
      {...props}
    >
      <div className="border-input-border-gray flex items-start justify-between border-b p-6 md:p-8">
        <div className="flex flex-col gap-2 pr-4">
          <h2 className="font-albert-sans text-2xl font-semibold leading-[30px] tracking-[-0.2px] text-black">
            Log out
          </h2>
          <p className="font-['Open_Sans'] text-sm font-normal leading-6 text-gray-700">
            Are you sure you want to log out from {theme.name}?
          </p>
        </div>
        <button
          onClick={onClose}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors hover:bg-gray-100"
          aria-label="Close modal"
        >
          <ExitIcon color="#22282F" />
        </button>
      </div>
      <div className="flex flex-col gap-3 p-6 md:p-8">
        <button
          type="button"
          onClick={handleLogout}
          className="bg-button-primary hover:bg-button-primary-hover inline-flex h-10 items-center justify-center gap-1.5 rounded-full px-6 py-2.5 font-['Open_Sans'] text-base font-medium leading-5 text-white transition-colors disabled:cursor-not-allowed disabled:opacity-50"
        >
          Log out
        </button>
        <button
          type="button"
          onClick={onClose}
          className="bg-button-secondary hover:bg-button-secondary-hover text-button-primary inline-flex h-10 items-center justify-center gap-1.5 rounded-full px-6 py-2.5 font-['Open_Sans'] text-base font-medium leading-5 transition-colors disabled:cursor-not-allowed disabled:opacity-50"
        >
          Cancel
        </button>
      </div>
    </Dialog>
  );
};
